<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-24
    	描述：后台系统内容区域
    -->
  <div class="right-content pr">
    <!--头部-->
    <Head></Head>
    <!--内容区域-->
    <div class="right-content-box">
      <div class="subject-wrap">

        <router-view />

      </div>
      <div style="width: 100%;text-align: center;position: fixed;bottom: 0;left: 50%;transform: translateX(-50%)"><a style="color: #848589;font-size: 15px;font-family: 华文新魏, sans-serif;font-size: 16px;" align="left" href="https://beian.miit.gov.cn/" target='_blank'>沪ICP备2024094665号-1</a> </div>

    </div>

  </div>
</template>

<script>
  import Head from '@/views/layout/Head.vue';
  export default {
    components: {
      Head
    },
    data() {
      return {};
    },
    created() {},
    methods: {}
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/layout/RightContent.vue